import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_REMINDER]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_REMINDER]: (state, item) => removeItem(state, item)
}
